var N = Object.defineProperty;
var K = (a, t, e) => t in a ? N(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e;
var l = (a, t, e) => K(a, typeof t != "symbol" ? t + "" : t, e);
class B {
  constructor(t) {
    l(this, "client");
    this.client = t;
  }
}
const y = [];
for (let a = 0; a < 256; ++a)
  y.push((a + 256).toString(16).slice(1));
function j(a, t = 0) {
  return (y[a[t + 0]] + y[a[t + 1]] + y[a[t + 2]] + y[a[t + 3]] + "-" + y[a[t + 4]] + y[a[t + 5]] + "-" + y[a[t + 6]] + y[a[t + 7]] + "-" + y[a[t + 8]] + y[a[t + 9]] + "-" + y[a[t + 10]] + y[a[t + 11]] + y[a[t + 12]] + y[a[t + 13]] + y[a[t + 14]] + y[a[t + 15]]).toLowerCase();
}
let C;
const V = new Uint8Array(16);
function J() {
  if (!C) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    C = crypto.getRandomValues.bind(crypto);
  }
  return C(V);
}
const G = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), R = { randomUUID: G };
function x(a, t, e) {
  var i;
  if (R.randomUUID && !a)
    return R.randomUUID();
  a = a || {};
  const s = a.random ?? ((i = a.rng) == null ? void 0 : i.call(a)) ?? J();
  if (s.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, j(s);
}
class U extends B {
  getUser() {
    var s;
    const t = this.client.authStore.addAlternateUserId(), e = (s = this.client.authStore.user) == null ? void 0 : s.alternateUserId;
    return t && this.client.authStore.user && e !== t && this.client.authStore.save({
      userRecord: { ...this.client.authStore.user, alternateUserId: t }
    }), this.client.authStore.user;
  }
  setUser() {
    const t = {
      userId: this.client.authStore.generateUserId(),
      userType: "new_user",
      exp: this.client.authStore.getUserExpiration()
    }, e = this.client.authStore.addAlternateUserId();
    return e && (t.alternateUserId = e), this.client.authStore.save({
      userRecord: t,
      sessionRecord: {
        sessionId: x(),
        exp: this.client.authStore.getSessionExpiration()
      }
    }), t;
  }
  getOrCreateUser() {
    let t = this.getUser();
    return t || (t = this.setUser()), t;
  }
}
function A(a, t, e) {
  let s = `${encodeURIComponent(a)}=${encodeURIComponent(t)}`;
  if (e != null && e.expires) {
    const i = typeof e.expires == "number" ? new Date(Date.now() + e.expires * 864e5).toUTCString() : e.expires.toUTCString();
    s += `; expires=${i}`;
  }
  e != null && e.path && (s += `; path=${e.path}`), e != null && e.domain && (s += `; domain=${e.domain}`), e != null && e.secure && (s += "; secure"), document.cookie = s;
}
function q(a) {
  const t = document.cookie ? document.cookie.split("; ") : [];
  for (let e = 0; e < t.length; e++) {
    const [s, ...i] = t[e].split("=");
    if (decodeURIComponent(s) === a)
      return decodeURIComponent(i.join("="));
  }
}
function F(a, t) {
  A(a, "", {
    ...t,
    expires: /* @__PURE__ */ new Date(0)
  });
}
const I = /^[\t\u0020-\u007e\u0080-\u00ff]+$/;
function M(a, t) {
  const e = {};
  if (typeof a != "string")
    return e;
  const s = Object.assign({}, {}).decode || z;
  let i = 0;
  for (; i < a.length; ) {
    const n = a.indexOf("=", i);
    if (n === -1)
      break;
    let r = a.indexOf(";", i);
    if (r === -1)
      r = a.length;
    else if (r < n) {
      i = a.lastIndexOf(";", n - 1) + 1;
      continue;
    }
    const o = a.slice(i, n).trim();
    if (e[o] === void 0) {
      let c = a.slice(n + 1, r).trim();
      c.charCodeAt(0) === 34 && (c = c.slice(1, -1));
      try {
        e[o] = s(c);
      } catch {
        e[o] = c;
      }
    }
    i = r + 1;
  }
  return e;
}
function $(a, t, e) {
  const s = Object.assign({}, e || {}), i = s.encode || D;
  if (!I.test(a))
    throw new TypeError("argument name is invalid");
  const n = i(t);
  if (n && !I.test(n))
    throw new TypeError("argument val is invalid");
  let r = `${a}=${n}`;
  if (s.maxAge != null) {
    const o = s.maxAge - 0;
    if (Number.isNaN(o) || !Number.isFinite(o))
      throw new TypeError("option maxAge is invalid");
    r += `; Max-Age=${Math.floor(o)}`;
  }
  if (s.domain) {
    if (!I.test(s.domain))
      throw new TypeError("option domain is invalid");
    r += `; Domain=${s.domain}`;
  }
  if (s.path) {
    if (!I.test(s.path))
      throw new TypeError("option path is invalid");
    r += `; Path=${s.path}`;
  }
  if (s.expires) {
    if (!L(s.expires) || Number.isNaN(s.expires.valueOf()))
      throw new TypeError("option expires is invalid");
    r += `; Expires=${s.expires.toUTCString()}`;
  }
  if (s.httpOnly && (r += "; HttpOnly"), s.secure && (r += "; Secure"), s.priority)
    switch (typeof s.priority == "string" ? s.priority.toLowerCase() : s.priority) {
      case "low":
        r += "; Priority=Low";
        break;
      case "medium":
        r += "; Priority=Medium";
        break;
      case "high":
        r += "; Priority=High";
        break;
      default:
        throw new TypeError("option priority is invalid");
    }
  if (s.sameSite)
    switch (typeof s.sameSite == "string" ? s.sameSite.toLowerCase() : s.sameSite) {
      case !0:
        r += "; SameSite=Strict";
        break;
      case "lax":
        r += "; SameSite=Lax";
        break;
      case "strict":
        r += "; SameSite=Strict";
        break;
      case "none":
        r += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return r;
}
function z(a) {
  return a.indexOf("%") !== -1 ? decodeURIComponent(a) : a;
}
function D(a) {
  return encodeURIComponent(a);
}
function L(a) {
  return Object.prototype.toString.call(a) === "[object Date]" || a instanceof Date;
}
function Q() {
  return typeof process < "u" && process.versions !== null && process.versions.node !== null;
}
function E() {
  return typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
}
function H() {
  var a, t;
  const e = (a = process == null ? void 0 : process.versions) == null ? void 0 : a.node, s = (t = e == null ? void 0 : e.split(".")) == null ? void 0 : t.map((i) => Number.parseInt(i, 10));
  return (s == null ? void 0 : s.length) === 3 && s != null && s.every((i) => !Number.isNaN(i)) ? {
    major: s == null ? void 0 : s[0],
    minor: s == null ? void 0 : s[1],
    patch: s == null ? void 0 : s[2]
  } : null;
}
class X extends U {
  async getResultsById({
    elementId: t,
    options: e,
    queryId: s
  }) {
    var c, h, u;
    const i = (c = this.getOrCreateUser()) == null ? void 0 : c.userId, n = {
      element_ids: [t],
      pathname: E() ? window.location.pathname : "",
      // Pass pathname by default if in browser
      ...e
    }, r = (u = (h = this.client.authStore) == null ? void 0 : h.user) == null ? void 0 : u.alternateUserId;
    r && (n.alternate_user_id = r);
    const o = await this.client.send({
      url: `${this.getBaseUrl()}/v2/render/customers/${this.client.clientId}/users/${i}`,
      options: {
        body: JSON.stringify(n)
      },
      queryId: s
    });
    return this.formatGetResultsById(o);
  }
  async getResults({
    elementIds: t,
    options: e,
    queryId: s
  }) {
    var c, h, u;
    const i = (c = this.getOrCreateUser()) == null ? void 0 : c.userId, n = {
      element_ids: t,
      pathname: E() ? window.location.pathname : "",
      ...e
    }, r = (u = (h = this.client.authStore) == null ? void 0 : h.user) == null ? void 0 : u.alternateUserId;
    r && (n.alternate_user_id = r);
    const o = await this.client.send({
      url: `${this.getBaseUrl()}/v2/render/customers/${this.client.clientId}/users/${i}`,
      options: {
        body: JSON.stringify(n)
      },
      queryId: s
    });
    return this.formatGetResults(o);
  }
  formatGetResults(t) {
    const { render_data: e } = t || {};
    return e == null ? void 0 : e.reduce((s, i) => (s[i.element.id] = {
      items: i.prediction,
      title: i.element.title,
      ruleEngine: i.rule_engine_v,
      ruleset: i.element.ruleset
    }, s), {});
  }
  formatGetResultsById(t) {
    const { render_data: e } = t || {};
    return {
      items: e == null ? void 0 : e[0].prediction,
      title: e == null ? void 0 : e[0].element.title,
      ruleEngine: e == null ? void 0 : e[0].rule_engine_v,
      ruleset: e == null ? void 0 : e[0].element.ruleset
    };
  }
  getBaseUrl() {
    var e;
    const t = typeof ((e = this.client) == null ? void 0 : e.getEnv) == "function" ? this.client.getEnv() : this.client.getEnv;
    return t === "dev" ? "https://prediction-dev.xgen.dev" : t === "stage" ? "https://prediction-stage.xgen.dev" : "https://prediction.xgen.dev";
  }
}
class W extends U {
  async getResults({ query: t, options: e, queryId: s, autoTrack: i = !0 }) {
    var k, T, O, P;
    const n = x(), {
      deploymentId: r,
      pageSize: o = 60,
      forceDeepSearch: c,
      sortBy: h,
      sortOrder: u,
      facets: g,
      context: f = {},
      ...v
    } = e, p = {
      query: t,
      deployment_id: r,
      use_opensearch_neural_as_primary: c,
      field_sort: h,
      field_sort_order: u,
      context: f,
      ...v
    };
    if (g) {
      let b = "perform_new_faceting";
      g === "v1" && (b = "perform_faceting"), p[b] = !0;
    }
    const d = (T = (k = this.client.authStore) == null ? void 0 : k.user) == null ? void 0 : T.alternateUserId;
    d && (p.alternate_user_id = d);
    const S = (O = this.getOrCreateUser()) == null ? void 0 : O.userId, _ = this.client.track.createBatch();
    i && _.searchQuery({
      query: t,
      queryId: n,
      deploymentId: e.deploymentId
    });
    const m = await this.client.send({
      url: `${this.getBaseUrl()}/customers/${this.client.clientId}/users/${S}?page_size=${o}`,
      options: {
        body: JSON.stringify(p)
      },
      queryId: s
    });
    return i && (_.searchResult({
      query: t,
      queryId: n,
      deploymentId: e.deploymentId,
      items: (P = m == null ? void 0 : m.products_list) == null ? void 0 : P.map((b) => b.prod_code)
    }), _.send()), m.queryId = n, this.formatGetResults(m);
  }
  async getResultValues({
    productId: t,
    collection: e,
    queryId: s
  }) {
    var o;
    const i = (o = this.getOrCreateUser()) == null ? void 0 : o.userId, n = {
      collection: e
    };
    return t && (n.prod_code = t), await this.client.send({
      url: `${this.getBaseUrl()}/customers/${this.client.clientId}/users/${i}/product-values`,
      options: {
        body: JSON.stringify(n)
      },
      queryId: s
    });
  }
  async getCategoryPage({
    category: t,
    collection: e,
    page: s,
    queryId: i
  }) {
    var c;
    const n = (c = this.getOrCreateUser()) == null ? void 0 : c.userId, r = {
      category: t,
      collection: e
    };
    s && (r.page = s);
    const o = await this.client.send({
      url: `${this.getBaseUrl()}/customers/${this.client.clientId}/users/${n}/categories`,
      options: {
        body: JSON.stringify(r)
      },
      queryId: i
    });
    return this.formatGetResults(o);
  }
  async getTrendingSearches({
    collection: t,
    version: e,
    queryId: s
  }) {
    var r;
    const i = (r = this.getOrCreateUser()) == null ? void 0 : r.userId;
    return await this.client.send({
      url: `${this.getBaseUrl()}/${e || "v1"}/customers/${this.client.clientId}/users/${i}/collections/${t}/trending`,
      options: {
        method: "GET"
      },
      queryId: s
    });
  }
  formatGetResults(t) {
    return {
      items: t.products_list || [],
      page: t.page,
      totalResults: t.total_result,
      facets: t.facet_list ?? t.facet,
      sortedBy: t.sorted_by,
      isQueryTranslated: t.query_translated,
      isFromCache: t.is_from_cache,
      keyword: t.keyword,
      isUrlRedirect: t.is_url_redirect,
      urlRedirect: t.url_redirect,
      isCachedFilterApplied: t.is_cached_filter_applied,
      isKeywordConfigApplied: t.is_keyword_config_applied,
      searchTermMatches: t.search_term_matches,
      behaviorId: t.behavior_id,
      responseEngine: t.response_engine,
      variantMapping: t.product_code_variant_mapping,
      queryId: t.queryId
    };
  }
  getBaseUrl() {
    var e;
    const t = typeof ((e = this.client) == null ? void 0 : e.getEnv) == "function" ? this.client.getEnv() : this.client.getEnv;
    return t === "dev" ? "https://prompt-dev.xgen.dev" : t === "stage" ? "https://prompt-stage.xgen.dev" : "https://prompt.xgen.dev";
  }
}
class Y extends U {
  constructor() {
    super(...arguments);
    l(this, "baseTracking", new ee());
  }
  async pageView({ context: e, collection: s, url: i, referrer: n } = {}) {
    const r = this.baseTracking.createPageViewPayload({ context: e });
    return await this.trackEvents({ events: [r], collection: s, url: i, referrer: n });
  }
  async itemView({ item: e, context: s, collection: i, url: n, referrer: r }) {
    const o = this.baseTracking.createItemViewPayload({ item: e, context: s });
    return await this.trackEvents({ events: [o], collection: i, url: n, referrer: r });
  }
  async categoryView({ category: e, items: s, context: i, collection: n, url: r, referrer: o }) {
    const c = this.baseTracking.createCategoryViewPayload({ category: e, items: s, context: i });
    return await this.trackEvents({ events: [c], collection: n, url: r, referrer: o });
  }
  async addToCart({ item: e, context: s, collection: i, url: n, referrer: r }) {
    const o = this.baseTracking.createAddToCartPayload({ item: e, context: s });
    return await this.trackEvents({ events: [o], collection: i, url: n, referrer: r });
  }
  async purchaseOrder({
    items: e,
    orderId: s,
    tax: i,
    discount: n,
    context: r,
    collection: o,
    url: c,
    referrer: h
  }) {
    const u = this.baseTracking.createPurchaseOrderPayloads({
      items: e,
      orderId: s,
      tax: i,
      discount: n,
      context: r
    });
    return await this.trackEvents({ events: u, collection: o, url: c, referrer: h });
  }
  async elementView({ element: e, context: s, collection: i, url: n, referrer: r }) {
    const o = this.baseTracking.createElementViewPayload({ element: e, context: s });
    return await this.trackEvents({ events: [o], collection: i, url: n, referrer: r });
  }
  async elementRender({ element: e, context: s, collection: i, url: n, referrer: r }) {
    const o = this.baseTracking.createElementRenderPayload({ element: e, context: s });
    return await this.trackEvents({ events: [o], collection: i, url: n, referrer: r });
  }
  async elementClick({ element: e, item: s, context: i, collection: n, url: r, referrer: o }) {
    const c = this.baseTracking.createElementClickPayload({ element: e, item: s, context: i });
    return await this.trackEvents({ events: [c], collection: n, url: r, referrer: o });
  }
  async searchQuery({
    query: e,
    queryId: s,
    deploymentId: i,
    isTypeToSearch: n,
    page: r,
    filtersContext: o,
    context: c,
    collection: h,
    url: u,
    referrer: g
  }) {
    const f = this.baseTracking.createSearchQueryPayload({
      query: e,
      queryId: s,
      deploymentId: i,
      isTypeToSearch: n,
      page: r,
      filtersContext: o,
      context: c
    });
    return await this.trackEvents({ events: [f], collection: h, url: u, referrer: g });
  }
  async searchResult({
    query: e,
    queryId: s,
    deploymentId: i,
    items: n,
    isTypeToSearch: r,
    page: o,
    filtersContext: c,
    context: h,
    collection: u,
    url: g,
    referrer: f
  }) {
    const v = this.baseTracking.createSearchResultPayload({
      query: e,
      queryId: s,
      deploymentId: i,
      items: n,
      isTypeToSearch: r,
      page: o,
      filtersContext: c,
      context: h
    });
    return await this.trackEvents({ events: [v], collection: u, url: g, referrer: f });
  }
  async searchClick({
    query: e,
    queryId: s,
    deploymentId: i,
    page: n,
    item: r,
    items: o,
    context: c,
    collection: h,
    url: u,
    referrer: g
  }) {
    const f = this.baseTracking.createSearchClickPayload({
      query: e,
      queryId: s,
      deploymentId: i,
      page: n,
      item: r,
      items: o,
      context: c
    });
    return await this.trackEvents({ events: [f], collection: h, url: u, referrer: g });
  }
  async customEvent({ category: e, action: s, name: i, value: n, collection: r, url: o, referrer: c }) {
    const h = this.baseTracking.createCustomEventPayload({
      category: e,
      action: s,
      name: i,
      value: n
    });
    await this.trackEvents({ events: [h], collection: r, url: o, referrer: c });
  }
  async trackEvents({
    events: e,
    queryId: s,
    collection: i,
    url: n,
    referrer: r
  }) {
    var u;
    const o = new Headers({
      cstid: this.client.clientId
    }), c = (u = this.getOrCreateUser()) == null ? void 0 : u.userId, h = e == null ? void 0 : e.map((g) => ({
      ...this.getDefaultParams({ collection: i, url: n, referrer: r }),
      ...g
    }));
    return await this.client.send({
      url: `${this.getBaseUrl()}/customers/${this.client.clientId}/users/${c}/batch`,
      options: {
        headers: o,
        body: JSON.stringify(h)
      },
      queryId: s
    }), {
      message: "Event(s) tracked successfully",
      success: !0
    };
  }
  getDefaultParams({
    collection: e = "default",
    url: s = "",
    referrer: i = ""
  }) {
    var r;
    const n = {
      customer_id: this.client.clientId,
      user_type: (r = this.client.authStore.user) == null ? void 0 : r.userType,
      session_id: this.client.authStore.sessionId
    };
    return {
      rec: "1",
      idsite: this.client.trackerId,
      url: s || (E() ? document.URL : "") || "",
      urlref: i || (E() ? document == null ? void 0 : document.referrer : "") || "",
      locale: e,
      uid: JSON.stringify(n)
    };
  }
  createBatch() {
    return new Z(this, this.baseTracking);
  }
  getBaseUrl() {
    var s;
    const e = typeof ((s = this.client) == null ? void 0 : s.getEnv) == "function" ? this.client.getEnv() : this.client.getEnv;
    return e === "dev" || e === "stage" ? "https://tracker-eu-stage.xgen.dev" : "https://tracker.xgen.dev";
  }
}
class Z {
  constructor(t, e) {
    l(this, "items", []);
    l(this, "trackService");
    l(this, "baseTracking");
    this.trackService = t, this.baseTracking = e;
  }
  pageView({ context: t } = {}) {
    const e = this.baseTracking.createPageViewPayload({ context: t });
    this.items.push(e);
  }
  itemView({ item: t, context: e }) {
    const s = this.baseTracking.createItemViewPayload({ item: t, context: e });
    this.items.push(s);
  }
  categoryView({ category: t, items: e, context: s }) {
    const i = this.baseTracking.createCategoryViewPayload({ category: t, items: e, context: s });
    this.items.push(i);
  }
  addToCart({ item: t, context: e }) {
    const s = this.baseTracking.createAddToCartPayload({ item: t, context: e });
    this.items.push(s);
  }
  purchaseOrder({ items: t, orderId: e, tax: s, discount: i, context: n }) {
    const r = this.baseTracking.createPurchaseOrderPayloads({
      items: t,
      orderId: e,
      tax: s,
      discount: i,
      context: n
    });
    this.items.push(...r);
  }
  elementView({ element: t, context: e }) {
    const s = this.baseTracking.createElementViewPayload({ element: t, context: e });
    this.items.push(s);
  }
  elementRender({ element: t, context: e }) {
    const s = this.baseTracking.createElementRenderPayload({ element: t, context: e });
    this.items.push(s);
  }
  elementClick({ element: t, item: e, context: s }) {
    const i = this.baseTracking.createElementClickPayload({ element: t, item: e, context: s });
    this.items.push(i);
  }
  searchQuery({
    query: t,
    queryId: e,
    deploymentId: s,
    isTypeToSearch: i,
    page: n,
    filtersContext: r,
    context: o
  }) {
    const c = this.baseTracking.createSearchQueryPayload({
      query: t,
      queryId: e,
      deploymentId: s,
      isTypeToSearch: i,
      page: n,
      filtersContext: r,
      context: o
    });
    this.items.push(c);
  }
  searchResult({
    query: t,
    queryId: e,
    deploymentId: s,
    items: i,
    isTypeToSearch: n,
    page: r,
    filtersContext: o,
    context: c
  }) {
    const h = this.baseTracking.createSearchResultPayload({
      query: t,
      queryId: e,
      deploymentId: s,
      items: i,
      isTypeToSearch: n,
      page: r,
      filtersContext: o,
      context: c
    });
    this.items.push(h);
  }
  searchClick({ query: t, queryId: e, deploymentId: s, page: i, item: n, items: r, context: o }) {
    const c = this.baseTracking.createSearchClickPayload({
      query: t,
      queryId: e,
      deploymentId: s,
      page: i,
      item: n,
      items: r,
      context: o
    });
    this.items.push(c);
  }
  customEvent({ category: t, action: e, name: s, value: i }) {
    const n = this.baseTracking.createCustomEventPayload({
      category: t,
      action: e,
      name: s,
      value: i
    });
    this.items.push(n);
  }
  async send({ collection: t, url: e, referrer: s } = {}) {
    if (this.items.length === 0)
      return {
        data: {
          message: "No events to track",
          success: !0
        },
        error: null
      };
    const i = await this.trackService.trackEvents({ events: this.items, collection: t, url: e, referrer: s });
    return this.clear(), i;
  }
  clear() {
    this.items = [];
  }
}
class ee {
  createPageViewPayload({ context: t } = {}) {
    const e = {
      action_detail: "page_view",
      action_name: "page_view",
      action_type: "ecomm"
    };
    return t && (e.context = t), e;
  }
  createItemViewPayload({ item: t, context: e }) {
    const s = {
      cvar: JSON.stringify({
        2: ["_pkp", t.price],
        3: ["_pks", t.id],
        4: ["_pkn", t.name],
        5: ["_pkc", JSON.stringify({ currency_code: t.currency })]
      }),
      action_name: "product_view",
      action_detail: "product_view",
      action_type: "ecomm"
    };
    return e && (s.context = e), s;
  }
  createAddToCartPayload({ item: t, context: e }) {
    const s = [
      t.id,
      t.name,
      JSON.stringify({ currency_code: t.currency }),
      t.price,
      t.quantity
    ], i = {
      ec_items: JSON.stringify([s]),
      revenue: t.price * t.quantity,
      action_name: "product_add",
      action_detail: "product_add",
      action_type: "ecomm"
    };
    return e && (i.context = e), i;
  }
  createPurchaseOrderPayloads({
    items: t,
    orderId: e,
    tax: s,
    discount: i,
    context: n
  }) {
    const r = t == null ? void 0 : t.map((u) => [
      u.id,
      u.name,
      JSON.stringify({ currency_code: u.currency }),
      u.price,
      u.quantity || 1
    ]), o = r == null ? void 0 : r.map((u) => ({
      ec_items: JSON.stringify([u]),
      ec_id: e,
      action_name: "product_purchase",
      action_detail: "product_purchase",
      action_type: "ecomm",
      version: "2",
      context: n
    })), c = t == null ? void 0 : t.reduce((u, g) => u + g.price * g.quantity, 0), h = {
      ec_items: JSON.stringify(r),
      revenue: c,
      ec_id: e,
      ec_st: c,
      ec_tx: s || 0,
      ec_dt: String(i || 0),
      idgoal: "0",
      action_name: "purchase_order",
      action_detail: "purchase_order",
      action_type: "ecomm",
      version: "2",
      context: n
    };
    return [...o, h];
  }
  createCategoryViewPayload({ category: t, items: e, context: s }) {
    const i = {
      cvar: JSON.stringify({ 5: ["_pkc", t] }),
      action_name: "category_view",
      action_detail: "category_view",
      action_type: "ecomm",
      context: {
        plpProducts: e
      }
    };
    return s && (i.context = {
      ...i.context,
      ...s
    }), i;
  }
  createElementViewPayload({ element: t, context: e }) {
    const s = {
      c_n: t.id,
      c_t: t == null ? void 0 : t.items.join(","),
      c_i: "elementViewed",
      action_name: "content_tracking",
      action_detail: "element_view",
      action_type: "smart_element"
    };
    return e && (s.context = e), s;
  }
  createElementRenderPayload({ element: t, context: e }) {
    const s = {
      c_n: t.id,
      c_t: t == null ? void 0 : t.items.join(","),
      action_name: "content_tracking",
      action_detail: "element_impression",
      action_type: "smart_element"
    };
    return e && (s.context = e), s;
  }
  createElementClickPayload({ element: t, item: e, context: s }) {
    var n;
    const i = {
      c_n: t.id,
      c_p: e,
      c_t: ((n = t == null ? void 0 : t.items) == null ? void 0 : n.join(",")) || "",
      c_i: "elementClicked",
      action_name: "content_tracking",
      action_detail: "element_click",
      action_type: "smart_element"
    };
    return s && (i.context = {
      ...i.context,
      ...s
    }), i;
  }
  createSearchQueryPayload({
    query: t,
    queryId: e,
    deploymentId: s,
    isTypeToSearch: i,
    page: n,
    filtersContext: r,
    context: o
  }) {
    return {
      query_id: e,
      action_name: "search",
      action_detail: "search",
      action_type: "search_service",
      context: {
        ...o,
        query: t,
        deployment_id: s,
        is_type_to_search: i || !1,
        page: n || 0,
        filters_context: r
      }
    };
  }
  createSearchResultPayload({
    query: t,
    queryId: e,
    deploymentId: s,
    items: i,
    isTypeToSearch: n,
    page: r,
    filtersContext: o,
    context: c
  }) {
    return {
      c_n: s,
      c_t: (i == null ? void 0 : i.join(",")) || "",
      c_i: "searchResult",
      query_id: e,
      action_name: "content_tracking",
      action_detail: "search_result",
      action_type: "search_service",
      context: {
        ...c,
        query: t,
        deployment_id: s,
        is_type_to_search: n || !1,
        page: r || 0,
        filters_context: o
      }
    };
  }
  createSearchClickPayload({
    query: t,
    queryId: e,
    deploymentId: s,
    page: i,
    item: n,
    items: r,
    context: o
  }) {
    return {
      c_n: s,
      c_p: n,
      c_t: (r == null ? void 0 : r.join(",")) || "",
      c_i: "searchClicked",
      query_id: e,
      action_name: "content_tracking",
      action_detail: "search_click",
      action_type: "search_service",
      context: {
        ...o,
        query: t,
        deployment_id: s,
        page: i || 0
      }
    };
  }
  createCustomEventPayload({ category: t, action: e, name: s, value: i }) {
    return {
      e_c: t,
      e_a: e,
      e_n: s,
      e_v: i,
      action_name: "event_tracking",
      action_detail: e,
      action_type: t
    };
  }
}
class te {
  constructor({
    keyPrefix: t = "xgen_",
    tokenSuffix: e = "token",
    userSuffix: s = "user",
    sessionSuffix: i = "session",
    generateUserId: n = () => Math.random().toString(36).substring(2) + (/* @__PURE__ */ new Date()).getTime().toString(36),
    addAlternateUserId: r = () => {
    },
    getUserExpiration: o = () => Date.now() + 395 * 24 * 60 * 60 * 1e3,
    getSessionExpiration: c = () => Date.now() + 30 * 60 * 1e3
  } = {}) {
    l(this, "baseToken", null);
    l(this, "baseSession", null);
    l(this, "baseUser", null);
    l(this, "tokenKey");
    l(this, "userKey");
    l(this, "sessionKey");
    l(this, "getUserExpiration");
    l(this, "getSessionExpiration");
    l(this, "generateUserId");
    l(this, "addAlternateUserId");
    this.tokenKey = `${t}${e}`, this.userKey = `${t}${s}`, this.sessionKey = `${t}${i}`, this.getUserExpiration = o, this.getSessionExpiration = c, this.generateUserId = n, this.addAlternateUserId = r;
  }
  get token() {
    var t;
    return this.isExpired(this.baseToken) ? (this.baseToken = null, "") : ((t = this.baseToken) == null ? void 0 : t.token) || "";
  }
  get user() {
    return this.isExpired(this.baseUser) ? (this.baseUser = null, this.baseUser) : this.baseUser;
  }
  get sessionId() {
    var t;
    return this.isExpired(this.baseSession) ? (this.baseSession = null, "") : ((t = this.baseSession) == null ? void 0 : t.sessionId) || "";
  }
  isExpired(t) {
    return t ? t != null && t.exp ? Date.now() > t.exp : !1 : !0;
  }
  get cookieInfo() {
    return [
      {
        dataKey: "baseToken",
        cookieKey: this.tokenKey
      },
      {
        dataKey: "baseUser",
        cookieKey: this.userKey
      },
      {
        dataKey: "baseSession",
        cookieKey: this.sessionKey
      }
    ];
  }
  /**
   * Saves the provided new token and model data in the auth store.
   */
  save({
    tokenRecord: t,
    userRecord: e,
    sessionRecord: s
  }) {
    t && (this.baseToken = t), e && (this.baseUser = e), s && (this.baseSession = s);
  }
  /**
   * Removes the stored token and model data form the auth store.
   */
  clear() {
    this.baseToken = null, this.baseUser = null, this.baseSession = null;
  }
  loadFromCookie(t) {
    let e = {};
    for (const { dataKey: s, cookieKey: i } of this.cookieInfo) {
      const n = M(t)[i] || "";
      try {
        e[s] = JSON.parse(n), (e === null || typeof e != "object" || Array.isArray(e)) && (e = {});
      } catch {
      }
    }
    this.save({
      tokenRecord: (e == null ? void 0 : e.baseToken) || null,
      userRecord: (e == null ? void 0 : e.baseUser) || null,
      sessionRecord: (e == null ? void 0 : e.baseSession) || null
    });
  }
  exportToCookie(t) {
    const e = {
      secure: !0,
      sameSite: !0,
      httpOnly: !0,
      path: "/"
    };
    let s = [];
    for (const { cookieKey: i, dataKey: n } of this.cookieInfo) {
      const r = this[n];
      r != null && r.exp ? e.expires = new Date(r.exp) : e.expires = /* @__PURE__ */ new Date("1970-01-01");
      const o = Object.assign({}, e, t), c = $(i, JSON.stringify(r), o);
      typeof Blob < "u" ? new Blob([c]).size : c.length, s.push($(i, JSON.stringify(r), o));
    }
    return s;
  }
}
class se extends te {
  constructor() {
    super(...arguments);
    l(this, "storageFallback", {});
  }
  get token() {
    const e = this._storageGet(this.tokenKey);
    return this.isExpired(e) ? (this._storageRemove(this.tokenKey), "") : (e == null ? void 0 : e.token) || "";
  }
  get user() {
    const e = this._storageGet(this.userKey);
    return this.isExpired(e) ? (this._storageRemove(this.userKey), null) : e;
  }
  get sessionId() {
    const e = this._storageGet(this.sessionKey);
    return this.isExpired(e) ? (this._storageRemove(this.sessionKey), "") : (e == null ? void 0 : e.sessionId) || "";
  }
  save({
    tokenRecord: e,
    userRecord: s,
    sessionRecord: i
  }) {
    e && this._storageSet(this.tokenKey, e), s && this._storageSet(this.userKey, s), i && this._storageSet(this.sessionKey, i), super.save({ tokenRecord: e, userRecord: s, sessionRecord: i });
  }
  clear() {
    this._storageRemove(this.tokenKey), this._storageRemove(this.userKey), this._storageRemove(this.sessionKey), super.clear();
  }
  // private storage functions
  _storageGet(e) {
    if (this.isBrowserAndCookiesAvailable()) {
      const s = q(e) || "";
      try {
        return JSON.parse(s);
      } catch {
        return s;
      }
    }
    return this.storageFallback[e];
  }
  _storageSet(e, s) {
    if (this.isBrowserAndCookiesAvailable()) {
      const i = JSON.stringify(s);
      A(e, i, { expires: new Date(s.exp) });
    }
    this.storageFallback[e] = s;
  }
  _storageRemove(e) {
    this.isBrowserAndCookiesAvailable() && F(e), delete this.storageFallback[e];
  }
  isBrowserAndCookiesAvailable() {
    var e;
    return typeof window < "u" && typeof ((e = window == null ? void 0 : window.document) == null ? void 0 : e.cookie) == "string";
  }
}
class w extends Error {
  constructor(e) {
    var s;
    super("XGenClientResponseError");
    l(this, "url", "");
    l(this, "status", 0);
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    l(this, "response", {});
    l(this, "isAbort", !1);
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    l(this, "originalError", null);
    Object.setPrototypeOf(this, w.prototype), e !== null && typeof e == "object" && (this.url = typeof e.url == "string" ? e.url : "", this.status = typeof e.status == "number" ? e.status : 0, this.isAbort = !!e.isAbort, this.originalError = e.originalError, e.response !== null && typeof e.response == "object" ? this.response = e.response : e.data !== null && typeof e.data == "object" ? this.response = e.data : this.response = {}), !this.originalError && !(e instanceof w) && (this.originalError = e), typeof DOMException < "u" && e instanceof DOMException && (this.isAbort = !0), this.name = `XGenClientResponseError ${this.status}`, this.message = (s = this.response) == null ? void 0 : s.message, this.message || (this.message = "Something went wrong while processing your request.");
  }
  toJSON() {
    return { ...this };
  }
}
class ie {
  constructor({ key: t, secret: e, clientId: s, trackerId: i, getEnv: n = () => "prod", fetchFunc: r }) {
    l(this, "key");
    l(this, "secret");
    l(this, "trackerId");
    l(this, "clientId");
    l(this, "getEnv");
    l(this, "fetchFunc");
    l(this, "_search", null);
    l(this, "_recommend", null);
    l(this, "_track", null);
    l(this, "_authStore", null);
    l(this, "beforeSend");
    l(this, "afterSend");
    l(this, "cancelControllers", /* @__PURE__ */ new Map());
    if (!t || !e || !s || !i)
      throw new Error("key, secret, clientId, trackerId, and getLocale are required");
    if (Q()) {
      const o = H();
      o != null && o.major && (o == null ? void 0 : o.major) < 21 && console.warn(
        "The XGen SDK works best with Node.js version 21 or higher. If you must use a lower version, please pass in a custom fetch function. We recommend using node-fetch. See <docs> for more info."
      );
    }
    this.key = t, this.secret = e, this.clientId = s, this.trackerId = i, this.getEnv = n, this.fetchFunc = r;
  }
  get search() {
    if (!this._search)
      throw new Error("Search service not initialized");
    return this._search;
  }
  get recommend() {
    if (!this._recommend)
      throw new Error("Recommend service not initialized");
    return this._recommend;
  }
  get track() {
    if (!this._track)
      throw new Error("Track service not initialized");
    return this._track;
  }
  get authStore() {
    if (!this._authStore)
      throw new Error("Auth store not initialized");
    return this._authStore;
  }
  registerServices(t, e, s, i) {
    this._search = t, this._recommend = e, this._track = s, this._authStore = i;
  }
  cancelAll() {
    for (const t of this.cancelControllers.values())
      t.abort();
    this.cancelControllers.clear();
  }
  cancel(t) {
    var e;
    (e = this.cancelControllers.get(t)) == null || e.abort(), this.cancelControllers.delete(t);
  }
  async send({ url: t, options: e, queryId: s }) {
    const i = s || x();
    try {
      const n = new AbortController();
      this.cancelControllers.set(i, n);
      const r = new Headers({
        "Content-Type": "application/json"
      }), o = this.authStore.token;
      o ? r.append("access_token", o) : (r.append("x-api-key", this.key), r.append("x-api-secret", this.secret));
      const c = this.authStore.user;
      if (this.authStore.sessionId || ((c == null ? void 0 : c.userType) === "new_user" && (c.userType = "return_user", this.authStore.save({ userRecord: c })), this.authStore.save({
        sessionRecord: {
          sessionId: x(),
          exp: this.authStore.getSessionExpiration()
        }
      })), this.beforeSend) {
        const p = await this.beforeSend({ url: t, options: e });
        (typeof p.url < "u" || typeof p.options < "u") && (t = p.url || t, e = p.options || e);
      }
      const { headers: u, method: g, ...f } = e || {}, v = this.fetchFunc || fetch;
      if (u)
        for (const [p, d] of Object.entries(u))
          r.append(p, d);
      return v(t, {
        ...f,
        method: g || "POST",
        headers: r,
        keepalive: !0,
        signal: n.signal
      }).then(async (p) => {
        var S, _, m;
        let d = {};
        try {
          d = await p.json();
        } catch {
        }
        if ((S = d == null ? void 0 : d.user_data) != null && S.access_token && ((_ = d == null ? void 0 : d.user_data) != null && _.expiration_date) && this.authStore.save({
          tokenRecord: {
            token: d.user_data.access_token,
            exp: new Date((m = d == null ? void 0 : d.user_data) == null ? void 0 : m.expiration_date).getTime()
          }
        }), this.afterSend) {
          const k = await this.afterSend({ response: p, data: d });
          typeof k < "u" && (d = k);
        }
        if (!p.ok)
          throw new w({
            url: t,
            status: p == null ? void 0 : p.status,
            data: d
          });
        return d;
      }).catch((p) => {
        throw new w(p);
      });
    } finally {
      this.cancelControllers.delete(i);
    }
  }
}
class ne {
  constructor(t) {
    l(this, "serviceClient");
    l(this, "authStore");
    l(this, "cancelAll");
    l(this, "cancel");
    l(this, "search");
    l(this, "recommend");
    l(this, "track");
    this.serviceClient = new ie(t), this.cancelAll = this.serviceClient.cancelAll.bind(this.serviceClient), this.cancel = this.serviceClient.cancel.bind(this.serviceClient), this.search = new W(this.serviceClient), this.recommend = new X(this.serviceClient), this.track = new Y(this.serviceClient), this.authStore = t.authStore || new se(), this.serviceClient.registerServices(this.search, this.recommend, this.track, this.authStore);
  }
  get beforeSend() {
    return this.serviceClient.beforeSend;
  }
  set beforeSend(t) {
    this.serviceClient.beforeSend = t;
  }
  get afterSend() {
    return this.serviceClient.afterSend;
  }
  set afterSend(t) {
    this.serviceClient.afterSend = t;
  }
}
export {
  te as BaseAuthStore,
  se as LocalCookieAuthStore,
  ne as XGenClient,
  ne as default
};
